module.exports = __webpack_public_path__ + "img/contra-img.ee327134.svg";